import React from 'react';
import { ShieldIcon, StarIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/rvX61FSTSXRtWcXvGnJkpT/ChatGPT-Image-14-jul-2026_-08_19_46-p.m..webp';
export function FinalCTA() {
  return <section className="py-7 px-4 sm:px-6 bg-brand-navy text-white border-t-4 border-brand-gold text-center" data-id="element-41">
      <p className="text-sm font-heading font-bold text-brand-gold uppercase tracking-widest mb-2" data-id="element-42">
        UNE DERNIÈRE OPPORTUNITÉ
      </p>
      <div className="text-sm sm:text-base font-medium mb-4 leading-snug max-w-xl mx-auto text-white/90 space-y-2" data-id="element-43">
        <p data-id="element-44">
          Vos gymnastes méritent des entraînements structurés, motivants et
          parfaitement préparés.
        </p>
        <p data-id="element-45">
          Ne perdez plus des heures à chercher des exercices, construire des
          progressions ou organiser vos séances chaque semaine.
        </p>
        <p data-id="element-46">
          Avec GYMNASTIQUE PRO™, vous disposez d'un système complet pour
          préparer vos entraînements plus rapidement, faire progresser vos
          gymnastes et enseigner avec davantage de confiance.
        </p>
        <p className="font-bold text-white" data-id="element-47">
          Offrez-vous enfin l'outil que vous auriez aimé avoir dès votre premier
          entraînement.
        </p>
      </div>
      <a href="#pricing" className="block cursor-pointer mb-4" aria-label="Voir l'offre Gymnastique Pro" data-id="element-48">
        <img src={PRODUCT_IMG} alt="GYMNASTIQUE PRO, le système complet de planification 6-en-1" className="w-full max-w-[265px] mx-auto object-contain drop-shadow-2xl" data-id="element-49" />
      </a>
      <div className="bg-white/5 border border-white/10 rounded-xl p-3.5 mb-4 shadow-lg max-w-sm mx-auto" data-id="element-50">
        <p className="text-sm font-heading font-bold mb-1 uppercase tracking-wide text-white/90" data-id="element-51">
          🤸 GYMNASTIQUE PRO™
        </p>
        <p className="text-xs font-bold text-white/90 leading-snug" data-id="element-52">
          Le Système Complet de Planification 6-en-1 + 5 Bonus Premium
        </p>
        <p className="text-sm opacity-60 mt-2" data-id="element-53">
          Prix habituel : 97 € | Aujourd'hui seulement : 27 €
        </p>
      </div>
      <div className="mb-2" data-id="element-54">
        <CTAButton href="#pricing" variant="gold" data-id="element-55">
          🚀 OUI ! JE VEUX MON SYSTÈME GYMNASTIQUE PRO™
        </CTAButton>
      </div>
      <p className="text-xs font-bold text-white/80 mb-3" data-id="element-56">
        Accès immédiat • Livraison instantanée par e-mail
      </p>
      <div className="flex flex-col sm:flex-row justify-center items-center gap-1.5 sm:gap-5 text-[11px] sm:text-xs font-bold text-white/80" data-id="element-57">
        <div className="flex items-center gap-1.5" data-id="element-58">
          <ZapIcon className="w-4 h-4 text-brand-gold" data-id="element-59" />
          <span data-id="element-60">Accès immédiat</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-61">
          <StarIcon className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-62" />
          <span data-id="element-63">
            4,9/5 — Avis vérifiés de professeurs de gymnastique artistique
          </span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-64">
          <ShieldIcon className="w-4 h-4 text-brand-gold" data-id="element-65" />
          <span data-id="element-66">
            Garantie satisfait ou remboursé pendant 7 jours — Zéro risque
          </span>
        </div>
      </div>
    </section>;
}